import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const BrandingProvider = () => {
  const { currentBranding, isCustomBranding } = useSelector(state => state['Settings']);

  // Update CSS custom properties for theming
  useEffect(() => {
    if (!currentBranding) return;
    
    const root = document.documentElement;
    if (currentBranding['primaryColor']) root.style.setProperty('--primary-color', currentBranding['primaryColor']);
    if (currentBranding['secondaryColor']) root.style.setProperty('--secondary-color', currentBranding['secondaryColor']);
    if (currentBranding['textColor']) root.style.setProperty('--text-color', currentBranding['textColor']);
    if (currentBranding['textwhite']) root.style.setProperty('--textwhite-color', currentBranding['textwhite']);
  }, [currentBranding?.['primaryColor'], currentBranding?.['secondaryColor']]);

  // Update favicon dynamically
  useEffect(() => {
    if (!currentBranding?.['favicon']) return;

    const updateFavicon = (faviconUrl) => {
      // Remove existing favicons
      const existingFavicons = document.querySelectorAll('link[rel="shortcut icon"], link[rel="icon"]');
      existingFavicons.forEach(favicon => favicon.remove());

      // Add new favicon
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'shortcut icon';
      newFavicon.type = 'image/x-icon';
      newFavicon.href = faviconUrl;
      document.head.appendChild(newFavicon);

      // Also add a regular icon link
      const iconLink = document.createElement('link');
      iconLink.rel = 'icon';
      iconLink.type = 'image/x-icon';
      iconLink.href = faviconUrl;
      document.head.appendChild(iconLink);
    };

    updateFavicon(currentBranding['favicon']);
  }, [currentBranding?.['favicon']]);

  // Update title for auth pages (where Sidebar is not present)
  useEffect(() => {
    if (!currentBranding?.['agencyName']) return;
    
    // Only update if we're on auth pages (title starts with specific auth page names or is 'Loading...')
    const currentTitle = document.title;
    if (currentTitle === 'Loading...' || 
        currentTitle.startsWith('Login') || 
        currentTitle.startsWith('Sign Up') || 
        currentTitle.startsWith('Forgot Password') || 
        currentTitle.startsWith('Reset Password')) {
      // Extract the page name (everything before the first '|' or use current title if no '|')
      const pageName = currentTitle.includes('|') 
        ? currentTitle.split('|')[0].trim() 
        : (currentTitle === 'Loading...' ? '' : currentTitle);
      
      if (pageName && pageName !== 'Loading...') {
        document.title = `${pageName} | ${currentBranding['agencyName']}`;
      } else {
        document.title = currentBranding['agencyName'];
      }
    }
  }, [currentBranding?.['agencyName']]);

  // Note: Document title is managed by Sidebar component for main app pages
  // BrandingProvider handles favicon, theme colors, and auth page titles

  return null; // Component only applies side effects, doesn't render anything
};

export default BrandingProvider;